module.exports = __webpack_public_path__ + "static/media/tshirt-woman-front-min.9d087a2c.png";